import { Component, OnInit, ViewChild } from '@angular/core';

import { AuthService, BlockAbstractComponent, ParserService } from '@gallaghercp/core-frontend';

import { SwiperComponent, SwiperConfigInterface } from '@gallaghercp/core-swiper';
import { Autoplay, Navigation, Pagination, Scrollbar } from 'swiper';

@Component({
    selector: 'core-block-carousel',
    templateUrl: './block-carousel.component.html',
    styleUrl: './block-carousel.component.scss',
    standalone: false,
})
export class BlockCarouselComponent extends BlockAbstractComponent implements OnInit {
    @ViewChild('swiperRef')
    swiperRef?: SwiperComponent;

    swiperConfig: SwiperConfigInterface = {
        modules: [Navigation, Pagination, Scrollbar, Autoplay],
        slidesPerView: 1,
        effect: 'fade',
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: '.carousel-pagination',
            clickable: true,
        },
    };

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
    ) {
        super(parser, auth);
    }

    override ngOnInit(): void {
        super.ngOnInit();
    }

    prev() {
        this.swiperRef?.directiveRef?.prevSlide();
    }

    next() {
        this.swiperRef?.directiveRef?.nextSlide();
    }
}
